import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faAddressBook, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { environment } from 'src/environments/environment';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
})
export class ContactFormComponent {
  buttonTextForForm = 'Send';
  contactForm: FormGroup;
  icons: { [key: string]: IconProp } = {
    faFacebook,
    faWhatsapp,
    faLinkedin,
    faEnvelope,
    faInstagram,
    faYoutube,
    faTiktok,
    faAddressBook,
  };
  soicalMediaLinks: any = [];
  whatsappLink = '';
  whatsappNumber = '';
  emailpath = '';
  locations!: string;
  emails!: string;
  contactImage = `/assets/${environment.projectName}/media/contactusComponents/contact.png`;
  whatAppPath = `/assets/${environment.projectName}/icons/whatsapp-logo.png`;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private fetchDataService: FetchDataService,
    private translate: TranslateService
  ) {
    this.contactForm = this.fb.group({
      fullName: [
        '',
        [Validators.required, Validators.pattern('^[\\u0600-\\u06FFa-zA-Z ]+$')],
      ],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('[0-9]+'),
          Validators.minLength(10),
          Validators.maxLength(13),
        ],
      ],
      message: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  ngOnInit() {
    this.fetchDataService.getSocialLinkes().subscribe({
      next: (data: any) => {
        this.soicalMediaLinks = data.soicalMediaLinks;
        this.locations = data.location;
        this.emails = data.email;
        this.whatsappLink = data.soicalMediaLinks.find(
          (item: any) => item.name === 'whatsapp'
        ).link;
        this.whatsappNumber = this.whatsappLink.split('wa.me/')[1];
        this.emailpath = data.soicalMediaLinks
          .find((item: any) => item.name === 'email')
          .link.split('mailto:')[1];
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }

  get fullName() {
    return this.contactForm.get('fullName');
  }
  get email() {
    return this.contactForm.get('email');
  }
  get phoneNumber() {
    return this.contactForm.get('phoneNumber');
  }
  get message() {
    return this.contactForm.get('message');
  }

  onSubmit() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      alert('Please fill out all required fields correctly.');
      return;
    }

    const formData = new FormData();
    formData.append('name', this.fullName?.value);
    formData.append('email', this.email?.value);
    formData.append('phone', this.phoneNumber?.value);
    formData.append('message', this.message?.value);

    const formEndpoint = 'https://formspree.io/f/xdkddlre';

    this.http
      .post(formEndpoint, formData, {
        headers: { Accept: 'application/json' },
      })
      .subscribe({
        next: () => {
          this.contactForm.reset();
          alert('Thanks for your submission!');
        },
        error: (err) => {
          if (err.error?.errors) {
            alert(err.error.errors.map((e: any) => e.message).join(', '));
          } else {
            alert('Oops! There was a problem submitting your form.');
          }
        },
      });
  }
}
